module.exports = __webpack_public_path__ + "img/logo-yabao.5b93bf5f.png";